export function isEmpty(v) {
    if (v === void 0) { v = ''; }
    return v == null ? true : v.length < 1;
}
